import { Box } from "@mui/material";
import React from "react";
import NewDeparment from "./Components/NewDeparment";
import NewDepartmentTable from "./Components/NewDepartmentTable";
import { useStyles } from "../../theme/styles";

const Category: React.FC = () => {
  const classes = useStyles();

  return (
    <Box sx={{ p: 2 }} className={classes.indexBox}>
      <NewDeparment />
      <Box sx={{ height: "75px" }} />
      <NewDepartmentTable />
    </Box>
  );
};

export default Category;
